var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.438 9.98a1.094 1.094 0 102.187 0 1.094 1.094 0 00-2.188 0zm5.468 0a1.094 1.094 0 102.188 0 1.094 1.094 0 00-2.188 0zm5.469 0a1.094 1.094 0 102.188 0 1.094 1.094 0 00-2.188 0z",
    fill: "#000"
  })));
}
export default SvgAnnotationMore;